"use client";

import Wrapper from "@/components/organisms/Wrapper";
import { Title } from "@/components/atoms/Title/title";
import Button from "@/components/atoms/Button";
import Header from "@/components/organisms/Header";
import RefreshIcon from "@/assets/svg/refresh.svg";
import ServerErrorIcon from "@/assets/svg/server-error-icon.svg";
import { useParams } from "next/navigation";
import { useContext } from "react";
import { GlobalContext } from "@/contexts/SiteDataContext";
import { Language } from "@/components/molecules/FooterDisclaimer/types";
import "@/styles/global-error.scss";

export default function Error({ error }: { error?: Error & { digest?: string } }) {
  const { lang } = useParams();
  const language = lang as Language;

  const { t } = useContext(GlobalContext).context;

  function onClick() {
    window.location.href = "/home";
  }
  return (
    <>
      <Header lang={language} />
      <Wrapper>
        <div
          className="serverError"
          style={{ justifyContent: "center" }}>
          <ServerErrorIcon
            className="serverError__icon"
            alt="Server Error Icon"
          />
          <Title
            hero
            className="serverError__title"
            tag="h1"
            content={t["Oops! Something went wrong."]}
          />
          <p className="serverError__copy">
            {t["We’re working on it."]} <br />
            {t["Please keep this page open or try again later."]}
          </p>
          {error && (
            <small className="serverError__copy serverError__copy--error">{error.message}</small>
          )}
          <Button
            onClick={onClick}
            tertiary
            noMargin
            iconLeft
            svg={<RefreshIcon />}
            label={t["Go to homepage"]}
          />
        </div>
      </Wrapper>
    </>
  );
}
